
import $ from 'jquery';

import 'jquery.easing';
import 'raf-polyfill';

import supportsPassiveEvents from './util/supports/passiveEvents';
import throttle from './util/throttle';
import globalelements from './global/elements';
import logger from './logger';


export default function (options) {
    var o = $.extend({
        // after the threshold, the sticky header autohides until scroll up
        threshold: 500,
        devMode: true
    }, options);


    var ele = {
        scrollTarget: globalelements.doc,

        page: globalelements.body
    };


    var internal = {
        name: 'ScrollDirection',

        scrollTop: 0,

        supportsPassiveEvents: supportsPassiveEvents(),

        scrollDirection: null,
        pastThreshold: null,

        rafIsTicking: false,
        firstEventFired: false,

        winHeight: globalelements.win.height(),
        winWidth: globalelements.win.width()
    };


    var fn = {
        init: function () {
            // set initial scroll top
            internal.scrollTop = fn.getScrollTop();

            fn.updateScrollDirection(internal.scrollTop, internal.scrollTop);

            // handlers
            ele.scrollTarget[0]
                .addEventListener('scroll', throttle(handlers.scroll, 200, {
                    leading: true
                }), internal.supportsPassiveEvents ? { passive: true } : false);
        },

        onScroll: function () {
            internal.rafIsTicking = false;

            var newScrollTop = fn.getScrollTop();

            if (internal.scrollTop !== newScrollTop) {
                fn.updateScrollDirection(internal.scrollTop, newScrollTop);
                internal.scrollTop = newScrollTop;
            }
        },

        updateScrollDirection: function (oldScrollTop, newScrollTop) {
            // set scroll direction
            if (newScrollTop > oldScrollTop &&
                internal.scrollDirection !== 'down') {
                internal.scrollDirection = 'down';
                globalelements.body.attr('data-scroll-direction', internal.scrollDirection);
                fn.console('scrolling *down*');
            } else if (newScrollTop < oldScrollTop &&
                internal.scrollDirection !== 'up') {
                internal.scrollDirection = 'up';
                globalelements.body.attr('data-scroll-direction', internal.scrollDirection);
                fn.console('scrolling *up*');
            }

            // see if past threshold
            if (newScrollTop > o.threshold && !internal.pastThreshold) {
                internal.pastThreshold = true;
                globalelements.body.attr('data-scroll-pastthreshold', internal.pastThreshold);
                fn.console('now *below* threshold');
            } else if (newScrollTop <= o.threshold && internal.pastThreshold) {
                internal.pastThreshold = false;
                globalelements.body.attr('data-scroll-pastthreshold', internal.pastThreshold);
                fn.console('now *above* threshold');
            }
        },

        getScrollTop: function () {
            return (window.pageYOffset || document.documentElement.scrollTop);
        },

        console: function (msgs) {
            logger(msgs, {
                enabled: o.devMode,
                prefix: internal.name + '.js',
                prefixColor: 'orange'
            });
        }
    };


    var handlers = {
        scroll: function () {
            if (!internal.rafIsTicking) {
                window.requestAnimationFrame(fn.onScroll);
            }
            internal.rafIsTicking = true;
        }
    };


    fn.init();
}
